import React, { Component } from "react";
import axios from "axios";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import Modal from "react-bootstrap/Modal";
import { Button, Flex } from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
import SendCredit from "./SendCredit";

export default class CreditPDF extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModalEmail: false,
			showModalSms: false,
			pdf: "",
			loading: true,
		};
	}

	getPDF = async () => {
		const url = api + `/credit/get/pdf/${this.props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);
			if (data.success) {
				this.setState({
					pdf: data.payload,
					loading: false,
				});
			} else {
				this.setState({
					loading: false,
				});
			}
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	/**
	 * Open and close email modal
	 * @param {Event} e event of the modal
	 */
	toggleModalEmail = (e) => {
		this.setState({
			showModalEmail: !this.state.showModalEmail,
		});
	};

	/**
	 * Open and close sms modal
	 * @param {Event} e event of the modal
	 */
	toggleModalSms = (e) => {
		this.setState({
			showModalSms: !this.state.showModalSms,
		});
	};

	componentDidMount() {
		this.getPDF();
	}

	render() {
		return (
			<Layout
				title="Credit PDF"
				description="PDF"
				className="container col-md-12"
			>
				<Flex gap={6}>
					<Button
						type="primary"
						size="large"
						loading={this.state.loading}
						disabled={this.state.loading}
						onClick={this.toggleModalEmail}
					>
						Send credit by email
					</Button>
					<Button
						type="primary"
						size="large"
						danger
						loading={this.state.loading}
						disabled={this.state.loading}
						onClick={this.toggleModalSms}
					>
						Send credit by SMS
					</Button>
				</Flex>

				<Modal
					show={this.state.showModalEmail}
					animation={false}
					onHide={this.toggleModalEmail}
				>
					<Modal.Header closeButton>
						<Modal.Title>Send Credit to:</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<SendCredit
							id={this.props.match.params.id}
							pcallback={this.toggleModalEmail}
							isEmail={true}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={this.state.showModalSms}
					animation={false}
					onHide={this.toggleModalSms}
				>
					<Modal.Header closeButton>
						<Modal.Title>Send Credit to:</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<SendCredit
							id={this.props.match.params.id}
							pcallback={this.toggleModalSms}
							isEmail={false}
						/>
					</Modal.Body>
				</Modal>
				{this.state.loading ? (
					<CustomSpinner />
				) : (
					<iframe src={this.state.pdf} width="95%" style={{ height: "90vh" }} />
				)}
			</Layout>
		);
	}
}
